import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Icon } from 'components/atoms'

export const LinkIcon = styled((props) => <Icon { ...props } />)`
  font-size: 0.75em;
  border-bottom: 1px solid transparent;

  &::before {
    border-bottom: 1px solid transparent;
    ${ (props) => props.position === 'left' && `margin-right: 6px;` }
    ${ (props) => props.position === 'right' && `margin-left: 6px;` }
  }

  &.icon-green {
    font-size: 32px;
    color: ${ (props) => props.theme.colors['aok-gruen'] };
  }
`

export const NativeLink = styled.a``

export const ReactLink = styled(Link)``
